import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "ab-account-performance-cards",
  templateUrl: "./performance-cards.component.html",
})
export class AccountPerformanceCardsComponent implements OnChanges {
  @Input() public data: any;
  @Input() public dur: string;
  public requestCount: number;
  public requestCountList: number[];
  public requestCodesBar: any;
  public errorRate: number;
  public errorRateCountList: number[];

  public ngOnChanges() {
    this.sumStats(this.data);
  }

  private sumStats(data: any) {
    this.requestCount = 0;
    this.requestCountList = [];
    this.requestCodesBar = {
      success: 0,
      redirection: 0,
      clientError: 0,
      serverError: 0,
    };
    let apmNoticeCount = 0;
    const apmNoticeCountList = [];

    for (const datum of data) {
      this.requestCount += datum.requestCount;
      this.requestCodesBar.success += datum.successCount;
      this.requestCodesBar.redirection += datum.redirectionCount;
      this.requestCodesBar.clientError += datum.clientErrorCount;
      this.requestCodesBar.serverError += datum.serverErrorCount;
      apmNoticeCount += datum.apmNoticeCount;

      for (let i = 0; i < datum.requestCountList.length; i++) {
        if (this.requestCountList[i] === undefined) {
          this.requestCountList[i] = datum.requestCountList[i];
        } else {
          this.requestCountList[i] += datum.requestCountList[i];
        }

        if (apmNoticeCountList[i] === undefined) {
          apmNoticeCountList[i] = datum.apmNoticeCountList[i];
        } else {
          apmNoticeCountList[i] += datum.apmNoticeCountList[i];
        }
      }
    }

    this.errorRateCountList = this.calculateErrorRateCountList(
      this.requestCountList,
      apmNoticeCountList,
    );

    if (this.requestCount > 0) {
      this.errorRate = 100 * (apmNoticeCount / this.requestCount);
    } else {
      this.errorRate = 0;
    }
  }

  private calculateErrorRateCountList(
    requestCountList: number[],
    apmNoticeCountList: number[],
  ) {
    const errorRateList: number[] = [];

    for (let i = 0; i < requestCountList.length; i++) {
      if (requestCountList[i] > 0) {
        errorRateList[i] = 100 * (apmNoticeCountList[i] / requestCountList[i]);
      } else {
        errorRateList[i] = 0;
      }
    }

    return errorRateList;
  }
}
